module.exports = __webpack_public_path__ + "static/images/gic.34630b4643846a09d9bf228e8fa2f6c9.jpg";